// constants
import { BOOKING_WORKFLOW_VALUE_NATIVE } from "@cloudspire/legacy-resources/src/constants/booking";

/**
 * Retourne vrai s'il s'agit d'une réservation classique.
 */
export default function bookingIsWorkflowNative({ booking }) {
  return BOOKING_WORKFLOW_VALUE_NATIVE === booking.workflow;
}
